import { render, staticRenderFns } from "./PhoneVerification.vue?vue&type=template&id=cef25a56&lang=pug&"
import script from "./PhoneVerification.vue?vue&type=script&lang=ts&"
export * from "./PhoneVerification.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneVerification.vue?vue&type=style&index=0&id=cef25a56&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports